import { VehicleEdit } from "./VehicleEdit";
import { VehicleCreate } from "./VehicleCreate";
import { VehiclesList } from "./VehiclesList";
import TruckOutlineIcon from "../../../common/icons/TruckOutlineIcon";

export default {
  icon: TruckOutlineIcon,
  list: VehiclesList,
  create: VehicleCreate,
  edit: VehicleEdit,
};
